import CategoryTag from "@components/CategoryTag";
import Link from "@components/Link";
import { ThemeEnum } from "@components/ThemeProvider/ThemeProvider";
import cx from "classnames";
import type { ReactElement } from "react";

type Props = Readonly<{
  title: string;
  urlPath: string;
  category: string;
  section: string;
  className?: string;
}>;

export default function HorizontalCard({
  title,
  urlPath,
  category,
  className,
  section,
  ...props
}: Props): ReactElement {
  return (
    <div id="horizontal-card" data-testid="horizontal-card" {...props}>
      <Link
        to={urlPath}
        className={cx(
          "group mx-3 grid cursor-pointer grid-cols-7 items-start gap-3 py-4",
          className,
        )}
      >
        <div className={cx("grid gap-2", "col-span-7")}>
          <CategoryTag
            theme={ThemeEnum.light}
            name={category}
            href={`/${section}`}
          />

          <h4 className="text-header-4 text-primary dark:text-primary-on-dark group-hover:text-link-video-hover line-clamp-3 transition duration-200">
            {title}
          </h4>
        </div>
      </Link>
    </div>
  );
}
